import { useClient } from '@cortex/react-query';
import { useQuery } from '@tanstack/react-query';
import { Link, createFileRoute, redirect } from '@tanstack/react-router';

import { PageHeader } from '../../components/common/PageHeader';
import { routes } from '../../lib/constants';
import { decodeJwt, hasRealmRole } from '../../lib/jwt';
import { getRealmStats } from '../../lib/orgs';

export const Route = createFileRoute('/internal/')({
  beforeLoad: () => guardSuperuser(),
  component: AdminDashboard,
});

// Route guard reused across all /internal/* routes. Reads from oidc-client-ts
// localStorage because hooks aren't usable here. If the token is absent or
// missing the role, redirect home.
export function guardSuperuser() {
  try {
    const keys = Object.keys(window.localStorage);
    for (const k of keys) {
      if (k.startsWith('oidc.user:')) {
        const blob = JSON.parse(window.localStorage.getItem(k) ?? 'null');
        const token = (blob?.access_token as string | undefined) ?? null;
        if (token && hasRealmRole(decodeJwt(token), 'superuser')) return;
      }
    }
  } catch (err: unknown) {
    console.warn('console/admin:guardSuperuser', err);
  }
  throw redirect({ to: routes.CHAT });
}

function AdminDashboard() {
  const client = useClient();
  const stats = useQuery({
    queryKey: ['admin', 'realm-stats'],
    queryFn: () => getRealmStats(client),
  });

  return (
    <>
      <PageHeader
        title="Cortex admin"
        actions={
          <Link to={routes.INTERNAL_ORGS} className="btn btn--secondary btn--sm">
            Manage organizations
          </Link>
        }
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap: 'var(--sp-3)',
        }}
      >
        <Kpi label="ORGANIZATIONS" value={stats.data ? stats.data.organizationCount : '—'} />
        <Kpi label="USERS · TOTAL" value={stats.data ? stats.data.userCount : '—'} />
      </div>
    </>
  );
}

function Kpi({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="fk-kpi-metric-card">
      <span className="fk-kpi-metric-card__label">{label}</span>
      <span className="fk-kpi-metric-card__value">{value}</span>
    </div>
  );
}
